import { Resources } from 'locales/localeType';
import { LaunchCalendarItem } from 'ui/components/LaunchCalendar/LaunchCalendarList';

type ItemsSeparatedByMonth = {
  year: number;
  month: number;
  longMonth: keyof Resources;
  items: LaunchCalendarItem[];
};

export const useContentSplitByMonth = (items: LaunchCalendarItem[]) => {
  const itemsSeparatedByMonth = items
    .filter(item => !item.released)
    .reduce<{ [key: number]: ItemsSeparatedByMonth }>((result, item) => {
      const date = new Date(item.launchDate);
      const year = date.getFullYear();
      const longMonth = date.toLocaleString('en-GB', {
        month: 'long',
      });

      // set object key as current month + 1 (0 is jan) and then append the year
      // this will keep the order of months eg: 202312, 202401
      const month = date.getMonth() + 1;
      const monthNumStr = month < 10 ? `0${month}` : `${month}`;
      const yearMonthIndex = parseInt(`${year}${monthNumStr}`);

      result[yearMonthIndex] = {
        year,
        month: date.getMonth(),
        longMonth: longMonth.toLowerCase() as keyof Resources,
        items: [...new Set(result[yearMonthIndex]?.items), item],
      };

      return result;
    }, {});

  return Object.values(itemsSeparatedByMonth);
};
